import { baseApi, apiTags } from "../baseApi";
import type { RefuseReason, UpdateRefuseReasonParams } from "../types/api.types";
export interface Resource {
    id: number;
    text?: string | null;
    icon?: string | null;
    color?: string | null;
    is_active?: boolean;
}

export const settingsApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getRefuseReasons: builder.query<RefuseReason[], void>({
            query: () => ({
                resource: "crm-refuse-reasons",
                action: "index",
                method: "GET",
                useAll: true,
            }),
            providesTags: (result) =>
                result && Array.isArray(result)
                    ? [
                          { type: apiTags.Settings, id: "REFUSE_REASONS" },
                          ...result.map((item) => ({ type: apiTags.Settings, id: `REFUSE_REASON_${item.id}` })),
                      ]
                    : [{ type: apiTags.Settings, id: "REFUSE_REASONS" }],
        }),
        updateRefuseReason: builder.mutation<RefuseReason, UpdateRefuseReasonParams>({
            query: ({ id, active }) => ({
                resource: "crm-refuse-reasons",
                action: "update",
                method: "PUT",
                id: id,
                data: { is_active: active },
            }),
            invalidatesTags: (result, error, arg) => [
                { type: apiTags.Settings, id: "REFUSE_REASONS" },
                { type: apiTags.Settings, id: `REFUSE_REASON_${arg.id}` },
            ],
        }),
        getResources: builder.query<Resource[], void>({
            query: () => ({
                resource: "crm-resource",
                action: "index",
                method: "GET",
                useAll: true,
            }),
            providesTags: (result) =>
                result && Array.isArray(result)
                    ? [
                          { type: apiTags.Settings, id: "RESOURCES" },
                          ...result.map((item) => ({ type: apiTags.Settings, id: `RESOURCE_${item.id}` })),
                      ]
                    : [{ type: apiTags.Settings, id: "RESOURCES" }],
        }),
        updateResource: builder.mutation<Resource, { id: number; is_active: boolean }>({
            query: ({ id, is_active }) => ({
                resource: "crm-resource",
                action: "update",
                method: "PUT",
                id: id,
                data: { is_active: is_active ? 1 : 0 },
            }),
            invalidatesTags: (result, error, arg) => [
                { type: apiTags.Settings, id: "RESOURCES" },
                { type: apiTags.Settings, id: `RESOURCE_${arg.id}` },
            ],
        }),
    }),
});

export const { useGetRefuseReasonsQuery, useUpdateRefuseReasonMutation, useGetResourcesQuery, useUpdateResourceMutation } =
    settingsApi;
